import axiosInstanceAuth from "@components/axiosInstances";
import { PayloadForgotPassword } from "./types";

export const ENDPOINT_URL = {
    REQUEST_FORGOT_PASSWORD: '/api/auth/forgot-password'
}

const RequestForgotPassword = async (payload: PayloadForgotPassword) => {

    try {
        const url = ENDPOINT_URL.REQUEST_FORGOT_PASSWORD;
        const response = await axiosInstanceAuth.post(url, payload);
        return response.data.data
    } catch (error) {
        throw error
    }
}

export const ForgotPasswordMutations = {
    RequestForgotPassword
}
